// src/pages/InstitutionalPage.tsx
import React from 'react';
import {
    Container,
    Box,
    Typography,
    Stack,
    CardMedia,
} from '@mui/material';
import AboutUs from "@/pages/public/institutional/components/AboutUs";
import InstitucionalDocuments from '@/components/common/institutionalDocuments';
import ContactUs from '@/pages/public/institutional/components/ContactUs';
import InstitutionalSymbols from '@/pages/public/institutional/components/InstitutionalSymbols';


const InstitutionalPage: React.FC = () => {
    return (
        <Box sx={{ backgroundColor: '#F8F9FA' }}>
            {/* Hero Section */}

            <AboutUs />

            <InstitucionalDocuments />

            {/* Enfoque Educativo Section */}
            <Container maxWidth="xl" sx={{ py: { xs: 6, sm: 7, md: 8 }, px: { xs: 2, sm: 3, md: 4 } }}>
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    alignItems="center"
                    spacing={{ xs: 4, md: 6 }}
                >
                    <Box sx={{ flex: 1 }}>
                        <CardMedia
                            component="img"
                            src={'/images/img10.jpg'}
                            alt="Enfoque Educativo"
                            height="400px"
                            sx={{
                                objectFit: 'cover',
                                width: '100%',
                                borderRadius: { xs: 2, md: 3 },
                                boxShadow: 3,
                            }}
                        />
                    </Box>
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: { xs: 3, sm: 4, md: 6, lg: 8 } }}>
                        <Typography
                            variant="h2"
                            fontWeight={700}
                            gutterBottom
                            sx={{
                                color: 'primary.dark',
                                textAlign: 'center',
                                fontSize: { xs: '1.5rem', sm: '1.875rem', md: '2rem', lg: '2.25rem' },
                                lineHeight: 1.3
                            }}
                        >
                            Enfoque Educativo
                            <br />
                            Humanista-Constructivista
                        </Typography>
                        <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{
                                textAlign: 'center',
                                mx: { xs: 0, sm: 2, md: 4, lg: 10, xl: 15 },
                                fontSize: { xs: '0.938rem', sm: '1rem', md: '1.063rem' },
                                lineHeight: { xs: 1.6, md: 1.7 }
                            }}
                        >
                            Nuestro modelo pedagógico se fundamenta en la pedagogía del ser, donde el estudiante es el centro del proceso educativo.
                            Combinamos el enfoque humanista con tendencias constructivistas desde una perspectiva social-cognitiva.
                        </Typography>
                    </Box>
                </Stack>
            </Container>

            {/* Símbolos Institucionales: escudo, bandera e himno */}
            <InstitutionalSymbols />

            {/* Contact Us Section */}
            <ContactUs />

        </Box>
    );
};

export default InstitutionalPage;